import {TranslateService} from '@ngx-translate/core';

import {LocalizationService} from '../../../../../shared/localization/localization.service';
import {Chart} from '../../key-metrics.interfaces';
import {KeyMetricsTable} from '../../key-metrics.table';
import {ChartAbstract} from '../chart';

export abstract class Pie extends ChartAbstract {

  private labelFormat: any;

  protected constructor(chart: Chart,
                        translate: TranslateService,
                        localization: LocalizationService) {
    super(chart, translate, localization);
  }

  public createCircleChart() {
    this.tooltip = this.getTooltip((value) => value.data.category, true);
    this.legend = {
      orient: 'vertical',
      x: 'left',
      formatter: (value) => this.translate.instant(value)
    };
    this.series = [
      {
        type: 'pie',
        radius: '65%',
        center: ['55%', '55%'],
        data: this.chart.data,
        itemStyle: {
          normal: {
            label: {
              formatter: (value) => this.translate.instant(value.name)
            }
          },
          emphasis: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        }
      }
    ];

    if (this.chart.time) {
      this.legend.data = this.sortCategories(this.chart.data.map(item => item.name));
      this.series.data = this.chart.data;
    } else {
      this.series.data = this.chart.data.map((element) => {
        [element.name, element.category] = [element.category, element.name];
        return element;
      });

      this.legend.data = this.chart.data.map((element) => element.name);
    }

    this.table = new KeyMetricsTable(
      this.series.data.map((seriesValue: any) => this.translate.instant(seriesValue.name)),
      [this.translate.instant(this.series.data[0] ? this.series.data[0].category : '')],
      [this.translate.instant(this.series.data[0] ? this.series.data[0].category : '')],
      this.series.data.map((seriesValue: any) => [
        this.localization.localizeNumber(seriesValue.value, 'DECIMAL_2_DIGIT')
      ])
    );
  }

  public createLoadView(withTitle: boolean, withLabel: boolean): void {
    this.labelFormat = this.series[0].itemStyle.normal.label.formatter;
    super.createLoadView(withTitle, withLabel);
    if (withLabel) {
      this.series.forEach((value: any) => {
        value.itemStyle.normal.label.show = true;
        value.itemStyle.normal.label.formatter = (value) => `${
          this.translate.instant(value.name)
        } (${
          this.localization.localizeNumber(value.value, 'DECIMAL_2_DIGIT')
        }, ${
          value.percent
        }%)`;
      });
    }
    this.createChart();
  }

  public resetChart(): void {
    this.series.forEach((value: any) => {
      value.itemStyle.normal.label.show = true;
      value.itemStyle.normal.label.formatter = this.labelFormat;
    });
    super.resetChart();
  }
}
